// Module
var code = `<div>
  <sv-svg-icon aria-hidden="true" data-bind="css: cssClasses.error.icon" params="iconName: 'icon-alert_24x24', size: 'auto'">
  </sv-svg-icon>
  <span data-bind="css: cssClasses.error.item">
    <!-- ko template: { name: 'survey-string', data: error.locText } --><!-- /ko -->
  </span>
</div>`;
// Exports
export default code;